import type { UnitPresets } from "@/libs/units/presets";

export const usHpsStbd: UnitPresets = {
  "Generic.Power.Hydraulic": "hp",
  "Generic.Power.Real": "kW",
  "Generic.Power.Apparent": "kVA",
  "Generic.Current": "A",
  "Generic.Density": "lb/ft³",
  "Generic.FlowRate.Liquid": "STB/D",
  "Generic.FlowRate.Gas": "mscf/d",
  "Generic.Length.Large": "Feet",
  "Generic.Length.Small": "Inches",
  "Generic.Ratio.Liquid": "SCF/STB",
  "Generic.Mass": "lbs",
  "Generic.Pressure": "PSIG",
  "Generic.Speed": "ft/s",
  "Generic.Temperature": "F°",
  "Generic.Viscosity": "Centipoise",
  "Generic.Voltage": "V",
  "Generic.Volume": "gal",
  "Generic.VolumeRate.PI": "stb/d/psi",
  "Generic.Concentration": "ppm"
};
